import * as csstips from "csstips";
import * as React from "react";
import { style } from "typestyle";
import { CSSProperties } from "typestyle/lib/types";

type IJsxAny = JSX.Element | JSX.Element[] | null;

interface IMapControlsLayoutProps {
  topLeft?: IJsxAny;
  topCenter?: IJsxAny;
  topRight?: IJsxAny;
  middleLeft?: IJsxAny;
  middleCenter?: IJsxAny;
  middleRight?: IJsxAny;
  bottomLeft?: IJsxAny;
  bottomCenter?: IJsxAny;
  bottomRight?: IJsxAny;
}

export default function MapControlsLayout({
  topLeft,
  topCenter,
  topRight,
  middleLeft,
  middleCenter,
  middleRight,
  bottomLeft,
  bottomCenter,
  bottomRight,
}: IMapControlsLayoutProps): JSX.Element {
  return (
    <div
      className={style(
        csstips.vertical,
        csstips.fillParent,
        csstips.padding(8),
        { boxSizing: "border-box" },
      )}
    >
      <MapControlsRow left={topLeft} center={topCenter} right={topRight} />
      <div
        className={style(csstips.flex, {
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
        })}
      >
        <MapControlsRow
          left={middleLeft}
          center={middleCenter}
          right={middleRight}
          additionalStyle={{ alignItems: "flex-end" }}
        />
      </div>
      <MapControlsRow
        left={bottomLeft}
        center={bottomCenter}
        right={bottomRight}
        additionalStyle={{ alignItems: "flex-end" }}
      />
    </div>
  );
}

interface IMapControlsRowProps {
  left?: IJsxAny;
  center?: IJsxAny;
  right?: IJsxAny;
  additionalStyle?: CSSProperties;
}

const MapControlsRow = ({
  left,
  center,
  right,
  additionalStyle,
}: IMapControlsRowProps) => (
  <div
    className={style(
      csstips.content,
      csstips.horizontal,
      additionalStyle || {},
    )}
  >
    <div
      className={style(
        csstips.content,
        csstips.horizontal,
        csstips.horizontallySpaced(8),
        { pointerEvents: "all" },
      )}
    >
      {left ? left : null}
    </div>
    <div
      className={style(csstips.flex, csstips.horizontal, {
        justifyContent: "center",
        pointerEvents: "all",
      })}
    >
      {center ? center : null}
    </div>
    <div className={style(csstips.content, { pointerEvents: "all" })}>
      {right ? right : null}
    </div>
  </div>
);
